import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import XFilledSvg from "@ant-design/icons-svg/es/asn/XFilled";
import AntdIcon from "../components/AntdIcon";
var XFilled = function XFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: XFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  XFilled.displayName = 'XFilled';
}
export default /*#__PURE__*/React.forwardRef(XFilled);